import React from "react";
import { Button, ButtonProps } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

// A navigation button: outlined (blue text) with the "open" glyph after the label — the same icon used
// beside clickable colour names. Use for anything that leads to another page (opens in a new tab). All
// the usual Button props (startIcon, onClick, disabled, size, …) pass through, so the nav look lives in
// one place and can be changed here.
const NavButton = ({ children, sx, ...props }: ButtonProps) => (
  <Button
    variant="outlined"
    endIcon={<OpenInNewIcon fontSize="small" />}
    sx={{ boxShadow: 2, "&:hover": { boxShadow: 4 }, ...sx }}
    {...props}
  >
    {children}
  </Button>
);

export default NavButton;
